// Client-side digital-card PDF (bundled separately and loaded only on the digital-card page,
// since pdf-lib is heavy). Overlays the patient's form values onto the approved template PDF
// at /files/digital-card.pdf — no server, no PHI leaves the browser.
//
// NOTE: the x/y positions are ported from the legacy FPDI handler (top-left origin) and converted
// to pdf-lib's bottom-left origin. They need ONE visual QA pass against the rendered PDF — the
// template's exact coordinate units couldn't be verified here. Tweak POSITIONS below.
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

const FONT_SIZE = 22;
const TEXT_COLOR = rgb(0.2, 0.2, 0.2); // ~ #333

function formatDate(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  return m ? `${m[2]}/${m[3]}/${m[1]}` : (value || '');
}

// x = from left; top = from the TOP of the page (FPDF-style) — converted below.
function positions(f) {
  const items = [
    { text: `${f.firstName || ''} ${f.lastName || ''}`.trim(), x: 563, top: 662.5 },
    { text: formatDate(f.date), x: 578, top: 681.5 },
    { text: f.doctor || '', x: 579, top: 700.5 },
    { text: f.phone || '', x: 729, top: 681.5 },
  ];
  if (f.fax) items.push({ text: f.fax, x: 725, top: 700.5 });
  return items;
}

export async function generateDigitalCardPdf(fields) {
  const res = await fetch('/files/digital-card.pdf');
  if (!res.ok) throw new Error('Could not load the card template.');

  const pdf = await PDFDocument.load(await res.arrayBuffer());
  const page = pdf.getPage(0);
  const { height } = page.getSize();
  const font = await pdf.embedFont(StandardFonts.Helvetica);

  for (const { text, x, top } of positions(fields)) {
    if (text) page.drawText(String(text), { x, y: height - top, size: FONT_SIZE, font, color: TEXT_COLOR });
  }

  const blob = new Blob([await pdf.save()], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'digital-card.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// Exposed for the page's inline form handler.
window.generateDigitalCardPdf = (fields) =>
  generateDigitalCardPdf(fields).catch((err) => {
    console.error(err);
    alert('Sorry, the card could not be generated. Please try again.');
  });
